import React from 'react';
import ReactDOM from 'react-dom';
import Component from './Component';
import immutable from 'immutable';

export default class Handsontable extends Component {


	constructor(props) {
		super(props);
		this.data = props.value;
	}

	fixData(data) {
		if (!data) {
			data = [[''], ['']];
		}
		if (!data[0]) {
			data.push(['']);
		}
		if (data[0].length < this.props.config.colHeaders.length) {
			for (let i = 0; i < (this.props.config.colHeaders.length - data[0].length) + 1; i++) {
				data[0].push('');
			}
		}
		return data;
	}

	componentDidMount() {
		let data = this.fixData(this.props.value ? this.props.value.toJS() : null);
		const c = this.props.config;
		c.data = data;
		c.afterChange = () => {
			if (this.table && !this.loadingData) {
				this.data = immutable.fromJS(this.table.getData());
				this.handleChange();
			}
		};
		this.table = new window.Handsontable(ReactDOM.findDOMNode(this), c);
	}

	componentWillReceiveProps(nextProps) {
		if (this.data != nextProps.value) {
			this.data = nextProps.value;
			this.update();
		}
	}

	componentWillUnmount() {
		this.destroyHandsontable();
	}

	shouldComponentUpdate(nextProps) {
		return false;
	}

	update() {
		this.loadingData = true;
		this.table.loadData(this.data ? this.fixData(this.data.toJS()) : []);
		this.loadingData = false;
	}

	destroyHandsontable() {
		if (this.table) {
			this.table.destroy();
		}
	}

	handleChange() {
		if (this.props.onChange) {
			this.props.onChange(this.data);
		}
		if (this.props.onBlur) {
			this.props.onBlur(this.data);
		}
	}

	render() {
		return (
			<div></div>
		);
	}
}


// WEBPACK FOOTER //
// ./src/reactis/reactis-inputs/Handsontable.js